import { DataSource } from "@/datasources/consulte-grid";
import { FiltroFuncionarioModel } from '@/models/filtros/filtro-funcionario.model';
import FiltroFuncionarioService from "@/services/filtros/filtrofuncionario.service";
import { eTipoPesquisaFiltroFuncionarios } from "@/enums/eTipoPesquisaFiltroFuncionarios";

export default class FiltroFuncionarioDataSource extends DataSource<FiltroFuncionarioModel> {
    TipoPesquisa: eTipoPesquisaFiltroFuncionarios;

    constructor(pageNumber: number, rowsPerPage: number, rowsPageCount: number, totalRowCount: number, rows: FiltroFuncionarioModel[], EnumTipoPesquisaFiltroFuncionarios: eTipoPesquisaFiltroFuncionarios, onLoad?: (rows: any) => void) {
        super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<FiltroFuncionarioModel>())
        this.TipoPesquisa = EnumTipoPesquisaFiltroFuncionarios;
        if (onLoad)
            this.setOnLoad(onLoad);
    }

    async load(): Promise<any> {
        const result = ((await FiltroFuncionarioService.dadosIndexPaginado(this.pageNumber, this.rowsPerPage, this.filters, this.TipoPesquisa, this.sortDataField)).data as any) as DataSource<FiltroFuncionarioModel>;
        this.pageNumber = result.pageNumber;
        this.rowsPageCount = result.rowsPageCount;
        this.rowsPerPage = result.rowsPerPage;
        this.rows = result.rows;
        this.sortDataField = result.sortDataField;
        this.sortOrder = result.sortOrder;
        this.totalRowCount = result.totalRowCount;
        this.filters = result.filters;
        return super.load();
    }
}